/**
 * ページの読み込み状態
 */
export default {
    init: function () {
        document.addEventListener("DOMContentLoaded", function() {
            document.body.classList.add('is-ready');
        });

        window.addEventListener('load', function () {
            document.body.classList.add('is-loaded');
        });

        setTimeout(function () {
            document.body.classList.add('is-ready');
            document.body.classList.add('is-loaded');
        }, 3000);
    }
};
